import PropTypes from "prop-types"
import React, { useState, useRef } from "react"

import Button from "@atoms/Button/Button"
import useOutsideClick from "@atoms/UseOutsideClick/UseOutsideClick"
import FilterTextField from "@molecules/FilterTextField/FilterTextField"
import CheckboxGroup from "@molecules/CheckboxGroup/CheckboxGroup"

const DesktopCheckboxFilter = ({
  list,
  onSave,
  onCheck,
  label,
  initialState,
  groupName,
  textSearchSettings = { apply: false, placeholder: null },
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const checkboxGroupRef = useRef()
  const wrapperRef = useRef()
  const [filteredItems, setFilteredItems] = useState(list)

  useOutsideClick(wrapperRef, () => setIsFilterOpen(false))

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        className={`rounded-full text-sm leading-3 font-medium text-blue-900 ${
          isFilterOpen ? "bg-gray-100" : "bg-gray-50"
        } py-2.5 px-3.5 ring-blue-900 ring-inset hover:ring-2 ${
          Object.entries(initialState).length ? "ring-2" : ""
        }`}
        onClick={() => setIsFilterOpen(!isFilterOpen)}
      >
        {label}
      </button>
      {isFilterOpen && (
        <div className="absolute rounded-3xl top-20 bg-white shadow-2xl min-w-max z-10">
          {textSearchSettings.apply && (
            <div className={"p-3.5 pb-0"}>
              <FilterTextField
                listToFilter={filteredItems}
                updateList={setFilteredItems}
                initialList={list}
                placeholder={textSearchSettings.placeholder}
              />
            </div>
          )}
          <div className="p-3.5 max-h-96 overflow-y-auto">
            <CheckboxGroup
              list={filteredItems}
              onCheck={onCheck}
              initialState={initialState}
              ref={checkboxGroupRef}
              groupName={groupName}
            />
          </div>
          <div className="flex p-3.5 border-t border-solid border-gray-50">
            <Button
              variant="whiteBlue"
              customClasses="w-full"
              action={() => checkboxGroupRef?.current?.resetState()}
            >
              Tyhjennä
            </Button>
            <Button
              variant="blueWhite"
              customClasses="w-full"
              action={() => {
                onSave()
                setIsFilterOpen(false)
              }}
              margin="mr-0"
            >
              Tallenna
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

DesktopCheckboxFilter.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  initialState: PropTypes.objectOf(PropTypes.bool.isRequired),
  onSave: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  groupName: PropTypes.string,
}

export default DesktopCheckboxFilter
